(function () {
  // Every watch product type counts (Watch, Dress Watch, Sport Watch, Chronograph, GMT Watch...).
  function isWatch(type) {
    return /watch|chronograph/i.test(type || '');
  }

  function upsertMessage(cart) {
    // TGM cart summary slot first (M6), then the legacy subtotals block.
    var footer = document.querySelector('cart-drawer [data-tgm-promo-slot], .cart-drawer__footer');
    if (!footer) return;

    var watchQty = 0;
    (cart.items || []).forEach(function (item) {
      if (isWatch(item.product_type)) watchQty += item.quantity;
    });

    var el = footer.querySelector('.tgm-buy2save30-cart-progress');

    if (watchQty < 1) {
      if (el) el.remove();
      return;
    }

    if (!el) {
      el = document.createElement('p');
      el.className = 'tgm-buy2save30-cart-progress';
      footer.insertBefore(el, footer.firstChild);
    }

    if (watchQty === 1) {
      el.textContent = 'Add 1 more watch and save \u20ac30';
      el.classList.remove('tgm-buy2save30-cart-progress--active');
    } else {
      el.textContent = '\u20ac30 off, applied at checkout';
      el.classList.add('tgm-buy2save30-cart-progress--active');
    }
  }

  function refresh() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(upsertMessage)
      .catch(function () {});
  }

  var debounceTimer = null;
  function scheduleRefresh() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refresh, 150);
  }

  // Ignore mutations caused by this script's own message or by ticking timers; otherwise every
  // text update triggered another /cart.js request in an endless loop.
  var IGNORE = '.tgm-buy2save30-cart-progress, [data-tgm-promo-slot], tgm-cart-timer, countdown-timer, .cart-timer';
  var observer = new MutationObserver(function (records) {
    var relevant = records.some(function (record) {
      var node = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      return !(node && node.closest && node.closest(IGNORE));
    });
    if (relevant) scheduleRefresh();
  });

  function attachObserver() {
    var drawer = document.querySelector('cart-drawer, #CartDrawer');
    if (!drawer) return;
    observer.observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    attachObserver();
    refresh();
  });

  document.addEventListener('cart:update', scheduleRefresh);
  document.addEventListener('cart:refresh', scheduleRefresh);
  document.addEventListener('cart:item-added', scheduleRefresh);
})();
